// React
import React from "react";

// Ant
import { Upload, message } from "antd";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

// Libs
import * as EventifyAPI from "../libs/EventifyAPI";

function getBase64BlobURL(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

// function getBase64BlobData(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsArrayBuffer(img);
// }

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  // const isLt2M = file.size / 1024 / 1024 < 2;
  // if (!isLt2M) {
  //   message.error("Image must smaller than 2MB!");
  // }
  return isJpgOrPng;
}

class InviteImageUpload extends React.Component {
  state = {
    loading: false
  };

  componentDidMount() {
    setTimeout(() => {
      console.log(this.props.list);
      if (this.props.list.eviteimages3resourceuri != null) {
        const baseURL = EventifyAPI.encodeS3URL(this.props.list.eviteimages3resourceuri);

        this.setState({ imageUrl: baseURL });
      }
    }, 250);
  }

  handleChange = info => {
    if (info.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }

    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64BlobURL(info.file.originFileObj, async imageUrl => {
          console.log(info.file.type);

          this.setState({
            imageUrl,
            loading: false
          });

          await EventifyAPI.setEviteCard(
            this.props.listid,
            info.file.name,
            imageUrl,
            info.file.type
          );
        }
      );
    }
  };

  render() {

    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    const { imageUrl } = this.state;
    return (
      <Upload
        name="avatar"
        listType="picture-card"
        className="invite-image-upload avatar-uploader"
        showUploadList={false}
        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        beforeUpload={beforeUpload}
        onChange={this.handleChange}
      >
        {imageUrl ? (
          <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
        ) : (
          uploadButton
        )}
      </Upload>
    );
  }
}

export default InviteImageUpload;
